import type { FlowDefinition } from '@tutlo/contracts'
import { FLOW_END } from './engine.ts'

/**
 * Flow `default`: kwalifikator z Figmy (sekcja `132:2753`, stan 2026-09-03) wg decyzji D1
 * (spec `docs/superpowers/specs/2026-09-03-m1-kwalifikator-design.md` §5.1):
 * cel → doprecyzowanie zależne od celu → poziom → czas → komplement. The name moved to `/konto`,
 * next to the e-mail (2026-10-25): as the first question it lost ~34% of the people who saw it.
 * Ilustracja per pytanie jest po stronie SPA (bez emoji na opcjach). Copy 1:1 z Figmy.
 * Walidacja schematem `flowDefinition` dzieje się w teście (`flows.test.ts`), nie przy imporcie.
 */
export const defaultFlow = {
  slug: 'default',
  title: 'Kwalifikator Tutlo',
  start: 'goal',
  questions: [
    {
      id: 'goal',
      title: 'W jakim celu chcesz uczyć się angielskiego?',
      options: [
        { value: 'work', label: 'Do pracy i kariery', next: 'work_ctx' },
        { value: 'exam', label: 'Do egzaminu lub certyfikatu', next: 'exam_ctx' },
        { value: 'travel', label: 'Do podróży lub życia za granicą', next: 'travel_ctx' },
        { value: 'talk', label: 'Do luźnej komunikacji na co dzień', next: 'talk_ctx' },
      ],
    },
    {
      id: 'work_ctx',
      title: 'W jakich sytuacjach zawodowych?',
      options: [
        { value: 'meetings', label: 'Spotkania i calle' },
        { value: 'mail', label: 'Maile' },
        { value: 'presentations', label: 'Prezentacje' },
        { value: 'recruitment', label: 'Rekrutacja' },
      ],
      next: 'level',
    },
    {
      id: 'exam_ctx',
      title: 'Jaki egzamin i na kiedy?',
      options: [
        { value: 'matura', label: 'Matura' },
        { value: 'ielts', label: 'IELTS/Cambridge' },
        { value: 'certificate', label: 'Certyfikat' },
        { value: 'unknown', label: 'Nie wiem' },
      ],
      next: 'level',
    },
    {
      id: 'travel_ctx',
      title: 'Czego potrzebujesz najpierw?',
      options: [
        { value: 'daily', label: 'Codzienne sytuacje' },
        { value: 'people', label: 'Rozmowy z ludźmi' },
        { value: 'formal', label: 'Formalności' },
        { value: 'confidence', label: 'Pewność siebie' },
      ],
      next: 'level',
    },
    {
      id: 'talk_ctx',
      title: 'O jakich tematach?',
      options: [
        { value: 'life', label: 'Życie codzienne' },
        { value: 'work', label: 'Praca' },
        { value: 'travel', label: 'Podróże/kultura' },
        { value: 'fun', label: 'Rozrywka' },
      ],
      next: 'level',
    },
    {
      id: 'level',
      title: 'Jak radzisz sobie z angielskim?',
      options: [
        { value: 'a0', label: 'Uczę się od podstaw' },
        { value: 'a2', label: 'Rozumiem więcej, niż mówię' },
        { value: 'b1', label: 'Mówię, ale potrzebuję chwili do namysłu' },
        { value: 'b2', label: 'Mówię od razu swobodnie' },
      ],
      next: 'time',
    },
    {
      // Figma ma dwa pytania o czas („Ile czasu…” i „Jak często w miesiącu…”) z notką „tylko 1 z tych dwóch”.
      // Wybrane pierwsze; zamiana = podmiana tego wpisu.
      id: 'time',
      title: 'Ile czasu chcesz poświęcać na naukę?',
      options: [
        { value: 'daily15', label: '15 minut dziennie' },
        { value: '2x30', label: '30 minut, 2× w tygodniu' },
        { value: 'weekend60', label: 'Godzina w weekend' },
        { value: 'unknown', label: 'Jeszcze nie wiem' },
      ],
      next: 'future',
    },
    {
      id: 'future',
      title: 'Wyobraź sobie komplement o Twoim angielskim za pół roku. Od kogo?',
      options: [
        { value: 'boss', label: 'Od szefa / współpracownika' },
        { value: 'stranger', label: 'Od kogoś nieznajomego' },
        { value: 'teacher', label: 'Od lektora' },
        { value: 'self', label: 'Od siebie samego' },
      ],
      next: FLOW_END,
    },
  ],
} satisfies FlowDefinition
